/* eslint-disable no-unused-vars */
import BaseService from './base.service'
import { ENDPOINT } from '~/api/endpoint'

class PhoneFixService extends BaseService {
  constructor(option) {
    super(option)
    return this
  }

  /* Danh sách bệnh nhân */
  getPhoneFixSortCondition() {
    return this.http.get(ENDPOINT.PHONEFIX_SORT)
      .then(res => res.data.data)
  }

  /* Danh sách bệnh nhân */
  getPhoneFixSearchCondition() {
    return this.http.get(ENDPOINT.PHONEFIX_SEARCH)
      .then(res => res.data.data)
  }

  /* Danh sách vị thuốc */
  getPhoneFixs(params) {
    return this.http.get(ENDPOINT.PHONEFIXS, { params })
      .then(res => res.data.data)
  }

  /* Chi tiết vị thuốc */
  getPhoneFix(PhoneFixId) {
    return this.http.get(ENDPOINT.PHONEFIX_DETAIL.replace('{id}', PhoneFixId))
      .then(res => res.data.data)
  }

  /* Tạo thông tin bài thuốc */
  createPhoneFix(data) {
    return this.http.post(ENDPOINT.CREATE_PHONEFIX, { data })
      .then(res => res.data.data)
  }
  /* Tạo thông tin bài thuốc */
  updatePhoneFix(PhoneFixId, data) {
    return this.http.put(ENDPOINT.PHONEFIX_DETAIL.replace('{id}', PhoneFixId), { data })
      .then(res => res.data.data)
  }

  /* Chi tiết vị thuốc */
  deletePhoneFixByID(PhoneFixId) {
    return this.http.delete(ENDPOINT.UPDATE_PHONEFIX.replace('{id}', PhoneFixId))
      .then(res => res.data.data)
  }

  uploadExcelFile(excelFile) {
    return this.http.post(ENDPOINT.UPLOAD_PHONEFIX, excelFile)
    .then(data => data.data)
  }
}

export default new PhoneFixService({ auth: true })
